import { render, staticRenderFns } from "./addGroupPolicy.vue?vue&type=template&id=44769508&scoped=true"
import script from "./addGroupPolicy.vue?vue&type=script&lang=js"
export * from "./addGroupPolicy.vue?vue&type=script&lang=js"
import style0 from "./addGroupPolicy.vue?vue&type=style&index=0&id=44769508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44769508",
  null
  
)

export default component.exports